import apiConfig from '../../config/api-config';

export const getServerTime = () => fetch(`${apiConfig.baseUrl}/server-time`, {
  method: 'get',
  credentials: 'include',
}).then((data) => data.json());
